import {useImperativeHandle, useState} from 'react';
import Swal from 'sweetalert2'
import {useNivelesEstructure} from "hooks/useNivelesEstructure";

function Search({getFlujosEstructure, setIsSearched, formRef}){
 const {allNivelesEstructure} = useNivelesEstructure();
 
 let allNivelesEstructureBarrioManzana = allNivelesEstructure.filter(nivel => nivel.flujo === "barrio-manzana");
 
 let nivelesMZ = allNivelesEstructureBarrioManzana.filter((nivel) => /MZ_TIPO_NIVEL/.test(nivel.nivel)).sort((a, b) => Number(a.nivel.slice(-1)) - Number(b.nivel.slice(-1)));

 let nivelesCP = allNivelesEstructureBarrioManzana.filter((nivel) => /CP_TIPO_NIVEL/.test(nivel.nivel)).sort((a, b) => Number(a.nivel.slice(-1)) - Number(b.nivel.slice(-1)));

 let nivelesIT = allNivelesEstructureBarrioManzana.filter((nivel) => /IT_TIPO_PLACA/.test(nivel.nivel))


 const [search, setSearch] = useState('')
 const [option, setOption] = useState('')

 useImperativeHandle(formRef, () => ({
        reset: () => {
            setOption('');
            setSearch('');
        }
    })
 );

 const showError = ({message}) => {
    Swal.fire({
        icon: 'warning',
        title: 'Oops...',
        text: message,
    })
 }
 const handleChangeOption = (e) => {
    if(e.target.value !== "nivel"){
        setSearch("");
    }
   setOption(e.target.value)

 }
 const handleChangeSearch = (e) => {
   setSearch(e.target.value)
 }
 const handleSubmit = (e) => {
    e.preventDefault();
    switch(option){
        case "":
            showError({message: 'Seleccione una opción de búsqueda'})
            break;            
        case "nivel":
            if(!search) return showError({message: "Seleccione un Nivel"});
            getFlujosEstructure({page: 1, [option]: search})
            setIsSearched({
                option,
                search,
                state: true
            })
            break
        default:
            getFlujosEstructure({})
            break

    }
 }
 return (
 <div>    
  <div className="row mb-2">
   <h6>Busqueda de Flujos</h6>
  </div>
  <div className="table-responsive rounded-3 d-flex justify-content-center" style={{border:'1px solid black'  , paddingTop:'15px'}}>
        <form className="row g-3">
            <div className="col-auto">
                <select onChange={handleChangeOption} className="form-select" aria-label="Default select example" value={option}>
                    <option value="">Seleccione</option>
                    <option value="nivel">Nivel</option>
                </select>
            </div>
            <div className="col-auto">
                {
                    option === "nivel"
                    ?
                    <select name="search" id="search" className="form-control" onChange={handleChangeSearch}  value={search}>
                        <option value="" disabled>--Seleccione--</option>
                        {nivelesMZ.map(nivel => (
                            <option key={nivel._id} value={nivel._id}>{nivel.nivel}</option>                        
                        ))}
                        {nivelesCP.map(nivel => (
                            <option key={nivel._id} value={nivel._id}>{nivel.nivel}</option>                        
                        ))}
                        {nivelesIT.map(nivel => (
                            <option key={nivel._id} value={nivel._id}>{nivel.nivel}</option>                        
                        ))}
                    </select>
                    :
                    <input type="text" className="form-control" id="search" name="search" onChange={handleChangeSearch} value={search}/>
                }
            </div>
            <div className="col-auto">
                <button type="submit" className="btn btn-primary mb-3" onClick={handleSubmit}>Buscar</button>
            </div>
        </form> 
    </div>
 </div>
 )
}
export default Search
